import { forwardRef, type HTMLAttributes, type ReactNode } from "react";
import "./ui.css";

export type ChipVariant =
	| "red"
	| "blue"
	| "green"
	| "grey"
	| "peach"
	| "warning";

interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
	variant: ChipVariant;
	children: ReactNode;
}

/* Forwards its ref and spreads the rest of its props ON PURPOSE. AntD overlays
   (Tooltip, Popover, Dropdown) clone their child and attach a ref plus mouse
   handlers to it. A plain function component swallows both: the handlers never
   fire, and AntD falls back to its findDOMNode/ResizeObserver path, which spins
   and can take the tab down when many chips mount at once (seen for real on the
   file-manager smart views, ~8 badges). Wrapping the chip in a bare <span> does
   NOT fix it — the ref has to reach a DOM node the overlay controls. */
export const Chip = forwardRef<HTMLSpanElement, ChipProps>(function Chip(
	{ variant, children, className, ...rest },
	ref,
) {
	return (
		<span
			ref={ref}
			className={`ui-chip ui-chip-${variant}${className ? ` ${className}` : ""}`}
			{...rest}
		>
			{children}
		</span>
	);
});
